import { S3Client } from '@aws-sdk/client-s3';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';

import { OutputErrorLog } from '../error';

import { COGNITO_USER_POOLS_ID, IDENTIFY_POOL_ID, REGION } from '@/utils/constant';

export const s3Client = ({
  idToken,
  cognitoRoleARN,
}: {
  idToken: string;
  cognitoRoleARN: string;
}) => {
  try {
    const cognitoUserPoolId = `cognito-idp.ap-northeast-1.amazonaws.com/${COGNITO_USER_POOLS_ID}`;
    //未認証ユーザーの場合、customROleARNとloginsはundefinedになる。
    const logins = idToken
      ? {
          [cognitoUserPoolId]: idToken,
        }
      : undefined;
    const customRoleArn = idToken ? cognitoRoleARN : undefined;
    const client = new S3Client({
      region: REGION,
      credentials: fromCognitoIdentityPool({
        identityPoolId: IDENTIFY_POOL_ID,
        clientConfig: {
          region: REGION,
        },
        customRoleArn,
        logins,
      }),
    });
    return client;
  } catch (error) {
    OutputErrorLog('s3Client', error);
    return null;
  }
};
